import React, { useState, useEffect, useCallback } from 'react'
import Style from './acl.module.sass';
import { Row, Col, Table, Dropdown, Menu, Tooltip, Form, Input } from 'antd';
import { Button, Modal } from '../../../helpers/commonUi'
import search from '../../../assets/images/searchicon.png';
import { ReactComponent as PlusIcon } from '../../../assets/svg/plus_btn.svg';
import { Http } from "../../../helpers/axois";
import { useParams } from 'react-router-dom';
// import { APIURL } from '../../../constant/common';
import { useToast } from '../../../helpers/commonFunction'
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg'
import { ReactComponent as Settings } from '../../../assets/svg/modalSettingsIcon.svg'
import { useSelector } from "react-redux";
import { AclGroup, VariableKey, AclVariable, FormBind } from "./aclInterface";
import NoData from '../NoData';
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'
import { AppState } from '../../../stateManager/store';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
    }
};

export const Acl: React.FC = () => {
    const [selectedGroup, setSelectedGroup] = useState<AclGroup | null>(null)
    const [selectedRowKeys, setSelectedRowKeys] = useState<VariableKey>([]);
    const { ErrorToast, SuccessToast } = useToast()
    const [visible, setVisible] = useState<boolean>(false)
    const [popUpState, setPopUpState] = useState<any>({})
    const [deleteModalVisible, setdeleteModalVisible] = useState<boolean>(false);
    const [deleteData, setDeleteData] = useState<AclGroup | null>(null);
    const [mode, setMode] = useState('')
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
    const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    var canViewAcl = (orgPermissions.includes('acl.View') && orgPermissions.includes('app.View')) || loggedInUserId==selectedOrg?.owner ;
  
    useEffect(() => {
        // empty selected members while switching teams
        setSelectedRowKeys([])
    }, [selectedGroup])
    const popUpContent = (group: AclGroup) => {
        return (
            <div className={Style.popUpContainer}>
                <div data-test-id="edit_group" className={Style.popUpItem} onClick={(e) => {
                    e.stopPropagation()
                    setGroupName(group.group_name || '')
                    setGroupDisplayName(group.group_display_name || '')
                    setGroupId(group.id || '')
                    setMode('edit')
                    setVisible(true)
                    setPopUpState({
                        [group.id || '']: false
                    })
                }}>
                    <Settings height='14px' width='14px' />
                    <span className={Style.popUpItemText}>Edit</span>
                </div>
                <div data-test-id="delete_group" className={Style.popUpItem} onClick={(e) => {
                    e.stopPropagation()
                    setdeleteModalVisible(true);
                    setDeleteData(group);
                    setPopUpState({
                        [group.id || '']: false
                    })
                }}>
                    <Delete height='14px' width='14px' />
                    <span className={Style.popUpItemText}>Delete</span>
                </div>
            </div>
        )
    }

    const onSelectChange = (rowKeys: VariableKey) => {
        setSelectedRowKeys(rowKeys);
    };

    const renderMembersTable = () => {
        const rowSelection: any = {
            selectedRowKeys,
            onChange: onSelectChange
        };

        const columns = [
            {
                title: 'Variable Name',
                dataIndex: 'var_name',
                width: "90%"
            }
        ];
        
        return (
            <div className={Style.membersTable}>
                <Table
                    data-test-id="acl-variable-table"
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={variableList}
                    className='override-table-container'
                    scroll={{ y: 'calc(100vh - 240px)' }}
                    pagination={false}
                    rowKey='id'
                /></div>);
    }

    const handleGroupClick = (group: AclGroup) => {
        setSelectedGroup(group)
    }

    const [groupName, setGroupName] = useState('')
    const [groupId, setGroupId] = useState('')
    const [groupDisplayName, setGroupDisplayName] = useState('')
    const params: {appId?: string} = useParams()
    const appId = params.appId
    const versionId = useSelector((state: any) => {
        return appId && state.apps.appVersion[appId].versionId
    })

    const createAclGroup = () => {
        if ((!orgPermissions.includes('acl.Create') || !orgPermissions.includes('app.View')) && loggedInUserId != selectedOrg?.owner) {
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        if (!groupName.trim() || !groupDisplayName.trim()) {
            ErrorToast("Group Name or Group Display Name should not be empty")
        } else {
            Http.post(`/apps/${appId}/aclGroups?versionId=${versionId}`, {
                group: {
                    groupName,
                    groupDisplayName
                }
            }).subscribe(() => {
                getAclGroups()
                SuccessToast('Group created successfully')
            }, (err) => {
                if (err == "Forbidden") {
                    ErrorToast("Not Authorized: Please request owner of this organization to provide access")
                } else {
                    ErrorToast((err && err.message) ? err.message : err)
                }
            })
        }
        setVisible(false)
    }

    const editAclGroup = () => {
        if ((!orgPermissions.includes('acl.Edit') || !orgPermissions.includes('app.View')) && loggedInUserId != selectedOrg?.owner) {
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        if (!groupName.trim() || !groupDisplayName.trim()) {
            ErrorToast("Group Name or Group Display Name should not be empty")
        } else {
            Http.put(`/apps/${appId}/aclGroups`, {
                group: {
                    id: groupId,
                    groupName,
                    groupDisplayName
                }
            }).subscribe(() => {
                getAclGroups()
                SuccessToast('Group updated successfully')
            }, (err) => {
                if (err == "Forbidden") {
                    ErrorToast("Not Authorized: Please request owner of this organization to provide access")
                } else {
                    ErrorToast((err && err.message) ? err.message : err)
                }
            })
        }
        setVisible(false)
    }

    const [groupList, setgroupList] = useState<AclGroup[]>([])
    const selectedGroupId = selectedGroup && selectedGroup.id

    const getAclGroups = useCallback(() => {
        Http.get(`/apps/${appId}/aclGroups?versionId=${versionId}`).subscribe((res: any) => {
            setgroupList(res)
            if(res.length === 0) {
                setSelectedGroup(null)
                setVariableList([])
            } else {
                if(!selectedGroupId){
                    setSelectedGroup(res[0])
                }
            }
        }, (err) => {
            if (err == "Forbidden") {
                canViewAcl = false
            }
        })
    }, [appId, selectedGroupId, versionId])

    useEffect(() => {
        getAclGroups()
    }, [getAclGroups])

    const deleteAclGroup = (groupId: string | undefined) => {
        if((!orgPermissions.includes('acl.Delete') || !orgPermissions.includes('app.View'))&& loggedInUserId!=selectedOrg?.owner){
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        groupId && Http.delete(`/apps/aclGroups/${groupId}?appId=${appId}`).subscribe(() => {
            getAclGroups()
            SuccessToast('Group successfully deleted')
        }, (err) => {
            if (err == "Forbidden") {
                ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            } else {
                ErrorToast((err && err.message) ? err.message : err)
            }
        })
        setdeleteModalVisible(false)
    }

    const [bindList, setBindList] = useState<FormBind[]>([])
    const [groupFilteredBindList, setGroupFilteredBindList] = useState<FormBind[]>([])
    const [searchFilteredBindList, setSearchFilteredBindList] = useState<FormBind[]>([])
    const [bindSearch, setBindSearch] = useState<string>('')

    useEffect(() => {
        Http.get(`/apps/${appId}/variables?versionId=${versionId}`).subscribe((res: any) => {
            setGroupFilteredBindList(res)
            setBindList(res)
        }, (err) => {
            if (err === "Forbidden") {
                canViewAcl = false
            }
        })
    },[appId, versionId])

    const usersMenu = (<Menu
        onClick={(e) => {
            const value = e.item.props.children
            setBindSearch(value)
            setSearchFilteredBindList(groupFilteredBindList.filter((item: FormBind) => item.bind.toLowerCase().includes(value.toLowerCase())))
            setVariableDropDownVisible(false)
        }}
        style={{ maxHeight: "250px", overflowY: "auto", marginLeft: "-25px" }}>
        {(() => {
            const uniqueBinds = new Set();
            if (
                searchFilteredBindList &&
                searchFilteredBindList.length > 0
            ) {
                return searchFilteredBindList
                    .slice(0, 25)
                    .map((data: FormBind, index: number) => {
                        if ( !uniqueBinds.has(data.bind) ) {
                            uniqueBinds.add(data.bind);
                            return (
                                <Menu.Item key={`${data.tabKey}${data.id}${index}`}>
                                    {data.bind}
                                </Menu.Item>
                            );
                        }
                    });
            }
        })()}
    </Menu>);

    const [variableDropDownVisible, setVariableDropDownVisible] = useState<boolean>(false)
    const [variableList, setVariableList] = useState<AclVariable[]>([])
    
    const getVariables = useCallback(() => {
        if(selectedGroup){
            Http.get(`/apps/${selectedGroup.id}/aclVariable?appId=${appId}`).subscribe((res: any) => {
                setVariableList(res)
                const filteredBindList = bindList.filter((item: FormBind) => !res.find((resItem: AclVariable) => resItem.var_name === item.bind))
                setGroupFilteredBindList(filteredBindList)
                setSearchFilteredBindList(filteredBindList)
            }, (err) => {
                if (err === "Forbidden") {
                    canViewAcl = false
                }
            })
        }
    }, [selectedGroup, bindList])

    useEffect(() => {
        getVariables()
    }, [getVariables])
    
    const addVariable = () => {
        if((!orgPermissions.includes('acl.Create') || !orgPermissions.includes('app.View'))&& loggedInUserId!=selectedOrg?.owner){
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        if(bindSearch && selectedGroup){
            const data = {
                variable: {
                    groupId: selectedGroup.id,
                    variableName: bindSearch
                }
            }
            Http.post(`/apps/aclVariable?appId=${appId}`, data).subscribe(() => {
                getVariables()
                setBindSearch('')
                SuccessToast('Variable added to group successfully')
            }, (err) => {
                var msg = 'Error in adding variable'
                if (err === "Forbidden") {
                    msg = "Not Authorized: Please request owner of this organization to provide access"
                }
                ErrorToast(msg)
            }) 
        } else {
            ErrorToast('Please provide a variable name')
        }
        
    }

    const removeVariables = () => {
        if((!orgPermissions.includes('acl.Delete') || !orgPermissions.includes('app.View'))&& loggedInUserId!=selectedOrg?.owner){
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        const data = {
            variableIds: selectedRowKeys
        }
        Http.post(`/apps/aclVariable/delete?appId=${appId}`, data).subscribe(() => {
            getVariables()
            SuccessToast('Variable(s) deleted successfully')
        }, (err) => {
            var msg = 'Error in removing variable'
            if (err === "Forbidden") {
                msg = "Not Authorized: Please request owner of this organization to provide access"
            }
            ErrorToast(msg)
        }
        )
    }

    return (
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",width:"100%"}}>
          { canViewAcl ? <>  <div data-test-id="acl-container" className={Style.teams}>
                <Row className="row">
                    <Col md={4} className={Style.teamsList}>
                        <div className={Style.header}>
                            <h5 data-test-id="acl-group-title" className={Style.title}>ACL GROUPS</h5>
                            <PlusIcon data-test-id="acl-group-create" width="24px" height="24px" onClick={() => {
                                setMode('create')
                                setGroupName('')
                                setVisible(true)
                            }} />
                        </div>
                        <div data-test-id="acl-group-list" className={Style.teamsDetails}>
                            {groupList.map((group: AclGroup, index) => {
                                return (
                                    <div
                                        key={group.id}
                                        onClick={() => handleGroupClick(group)}
                                        onContextMenu={(e) => {
                                            e.preventDefault()
                                            setPopUpState({
                                                [group.id || '']: true
                                            })
                                        }}
                                        data-test-id="group_name" className={(selectedGroup && selectedGroup.id) === group.id ? Style.selectedTeam : Style.singleTeam}
                                    >
                                        <Tooltip
                                            onVisibleChange={(value) => setPopUpState({
                                                [group.id || '']: value
                                            })}
                                            visible={popUpState[group.id || '']}
                                            placement='rightTop'
                                            overlayClassName='teamPopUp'
                                            title={() => popUpContent(group)}
                                            trigger='contextMenu'
                                            key={index}
                                        >
                                            <div className={Style.teamInfo}>
                                                <div data-test-id="acl-group-name" className={Style.teamName}>{group.group_name}</div>
                                            </div>
                                        </Tooltip>
                                    </div>
                                )
                            })}
                        </div>
                    </Col>
                    <Col md={20} className="col">
                        {
                            <div>
                                <div className={Style.mainorgs}>
                                    <div className={Style.mainSubOrgs}>
                                        <div className={Style.mainSubOrgsContent}>
                                            <h3>Process Variables</h3>
                                            <p>View variables under this group</p>
                                        </div>
                                        {
                                            selectedGroup ? 
                                            <div className={Style.memberTableActions}>
                                                <div id="newSearchWrapper" className={Style.search}>
                                                    <img src={search} alt="search" />
                                                    <Dropdown
                                                        overlay={searchFilteredBindList.length > 0 ? usersMenu : <></>}
                                                        visible={variableDropDownVisible}
                                                        overlayStyle={{ width: "250px", paddingTop: "3px"}}
                                                        onVisibleChange={(value: boolean) => setVariableDropDownVisible(value)}
                                                        trigger={['click']}
                                                    >
                                                        <input
                                                            type="search"
                                                            value={bindSearch} 
                                                            onChange={(e) => {
                                                                const value: string = e.target.value
                                                                setBindSearch(value)
                                                                if (value) {
                                                                    setSearchFilteredBindList(groupFilteredBindList.filter((item: FormBind) => item.bind.toLowerCase().includes(value.toLowerCase())))
                                                                } else {
                                                                   setSearchFilteredBindList([])
                                                               }
                                                            }}
                                                        />
                                                    </Dropdown>
                                                </div>
                                                <div className={Style.add}>
                                                    <Button dataTestId="acl-add-variable" size="small" onClick={() => addVariable()}>ADD</Button>
                                                </div>
                                                <Button dataTestId="acl-delete-variable" size="small" color='light-secondary' onClick={removeVariables}>
                                                    <div className={Style.delete}>
                                                        <Delete />
                                                        <span>DELETE</span>
                                                    </div>
                                                </Button>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>

                                    <div>
                                        {renderMembersTable()}
                                    </div>
                                </div>
                            </div>
                        }
                    </Col>
                </Row>
            </div >
            <Modal
                id="createEditACL"
                dataTestId="create_edit_acl_modal"
                unmountOnCancel={true}
                visible={visible}
                title={`${mode === 'create' ? 'CREATE' : 'EDIT'} ACL GROUP`}
                onCancel={() => {
                    setVisible(false);
                    setGroupName('')
                    setGroupDisplayName('')
                }}
                footer={{
                    enable: true,
                    okText: mode === 'create' ? 'CREATE' : 'UPDATE',
                    cancelText: 'CANCEL',
                    onOk: () => {
                        mode === 'create' ? createAclGroup() : editAclGroup()
                        setGroupName('')
                        setGroupDisplayName('')
                    }
                }}
            >
                <Form {...formItemLayout} className={Style.app + ' override-content'}>
                    <Form.Item label="Group Name">
                        <Input value={groupName} onChange={(e) => setGroupName(e.target.value)}></Input>
                    </Form.Item>
                    <Form.Item label="Group Display Name">
                        <Input value={groupDisplayName} onChange={(e) => setGroupDisplayName(e.target.value)}></Input>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                id="deleteAclGroup"
                dataTestId="deleteAclGroupModal"
                unmountOnCancel={true}
                visible={deleteModalVisible}
                title="DELETE ACL GROUP"
                onCancel={() => {
                    setdeleteModalVisible(false);
                }}
                deleteOptions={{
                    type: "Acl Group",
                    validateString: deleteData ? deleteData.group_name : undefined
                }}
                footer={{
                    enable: true,
                    okText: 'DELETE',
                    cancelText: 'CANCEL',
                    onOk: () => {
                        deleteAclGroup(deleteData ? deleteData.id : undefined)
                    }
                }}
            /> </> :
            <NoData 
            svg={WarningIcon}
            header='Not Authorized'
            content='Please request owner of this organization to provide access'
            noButton={true}
        />
            }
        </div>
    )
}
